import { render } from "./GestioneExportForm.vue?vue&type=template&id=0390f0bf&scoped=true"
import script from "./GestioneExportForm.vue?vue&type=script&lang=js"
export * from "./GestioneExportForm.vue?vue&type=script&lang=js"

import "./GestioneExportForm.vue?vue&type=style&index=0&id=0390f0bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0390f0bf"]])

export default __exports__